let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  try {
    if (!ctx || ctx.state === 'closed') {
      ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    return ctx;
  } catch {
    return null;
  }
}

function tone(freq: number, duration: number, type: OscillatorType = 'sine', gain = 0.3) {
  const c = getCtx();
  if (!c) return;
  try {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.connect(g);
    g.connect(c.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, c.currentTime);
    g.gain.setValueAtTime(gain, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + duration);
    osc.start(c.currentTime);
    osc.stop(c.currentTime + duration);
  } catch { /* ignore */ }
}

export function playBuzz() {
  const c = getCtx();
  if (!c) return;
  try {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.connect(g);
    g.connect(c.destination);
    osc.type = 'square';
    osc.frequency.setValueAtTime(200, c.currentTime);
    osc.frequency.exponentialRampToValueAtTime(600, c.currentTime + 0.08);
    osc.frequency.exponentialRampToValueAtTime(200, c.currentTime + 0.2);
    g.gain.setValueAtTime(0.4, c.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, c.currentTime + 0.3);
    osc.start(c.currentTime);
    osc.stop(c.currentTime + 0.3);
  } catch { /* ignore */ }
}

export function playCorrect() {
  tone(523, 0.12, 'sine', 0.25); // C5
  setTimeout(() => tone(659, 0.12, 'sine', 0.25), 100); // E5
  setTimeout(() => tone(784, 0.25, 'sine', 0.25), 200); // G5
}

export function playWrong() {
  tone(330, 0.15, 'sawtooth', 0.2);
  setTimeout(() => tone(247, 0.3, 'sawtooth', 0.2), 120);
}

export function playTick() {
  tone(1000, 0.05, 'square', 0.05);
}

export function playReveal() {
  tone(440, 0.08, 'sine', 0.15);
  setTimeout(() => tone(550, 0.08, 'sine', 0.15), 80);
  setTimeout(() => tone(660, 0.08, 'sine', 0.15), 160);
  setTimeout(() => tone(880, 0.2, 'sine', 0.2), 240);
}

export function playJoinSuccess() {
  tone(523, 0.1, 'sine', 0.2);  // C5
  setTimeout(() => tone(659, 0.1, 'sine', 0.2), 90);   // E5
  setTimeout(() => tone(784, 0.1, 'sine', 0.2), 180);  // G5
  setTimeout(() => tone(1047, 0.25, 'sine', 0.25), 270); // C6
}
